import { render, staticRenderFns } from "./CustomerLocationAreasComponent.vue?vue&type=template&id=6ce1ffcc"
import script from "./CustomerLocationAreasComponent.vue?vue&type=script&lang=js"
export * from "./CustomerLocationAreasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports